"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _AcceptAs = require("./AcceptAs.styled");
var _KnockRequestListItem = require("./KnockRequestListItem.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AcceptAs = function AcceptAs(_ref) {
  var sources = _ref.sources,
    onApprove = _ref.onApprove,
    name = _ref.name,
    isCheckHidden = _ref.isCheckHidden;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dropdownOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    sourceId = _useState4[0],
    setSourceId = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    displayName = _useState6[0],
    setDisplayName = _useState6[1];
  var getDefaultSource = function getDefaultSource(sources, name) {
    var presenterName = name === null || name === void 0 ? void 0 : name.toLowerCase();
    var defaultSource;

    // first check if there's a full name match
    defaultSource = sources.find(function (source) {
      var _source$title;
      return (source === null || source === void 0 ? void 0 : (_source$title = source.title) === null || _source$title === void 0 ? void 0 : _source$title.toLowerCase()) === presenterName;
    });

    // then check the first name if there's no full name match
    if (!defaultSource) {
      defaultSource = sources.find(function (source) {
        var firstName = source.title.split(' ')[0];
        return presenterName.includes(firstName === null || firstName === void 0 ? void 0 : firstName.toLowerCase());
      });
    }

    // check the last name for a match if first name failed
    if (!defaultSource) {
      defaultSource = sources.find(function (source) {
        var lastName = source.title.split(' ')[1];
        return lastName && presenterName.includes(lastName === null || lastName === void 0 ? void 0 : lastName.toLowerCase());
      });
    }

    // returns undefined if there's no match
    return defaultSource;
  };
  (0, _react.useEffect)(function () {
    var defaultSource = getDefaultSource(sources, name);
    if (displayName === '' && defaultSource) {
      setDisplayName(defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource.title);
      setSourceId(defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource._id);
    }
  }, [name, sources, displayName]);
  var toggle = function toggle() {
    return setOpen(!dropdownOpen);
  };
  var handleChange = function handleChange(e) {
    var _sources$find;
    var value = e.target.value;
    var displayName = (_sources$find = sources.find(function (source) {
      return source._id === value;
    })) === null || _sources$find === void 0 ? void 0 : _sources$find.title;
    setDisplayName(displayName);
    setSourceId(value);
  };
  var handleApprove = function handleApprove(e) {
    e.preventDefault();
    !sourceId ? onApprove() : onApprove(sourceId);
  };
  var approvalMessage = !displayName ? _react["default"].createElement(_react["default"].Fragment, null, "Approve as a new source \xA0") : _react["default"].createElement(_react["default"].Fragment, null, "Approve as", ' ', _react["default"].createElement(_AcceptAs.StyledName, {
    className: "dd-privacy-mask"
  }, "\xA0", displayName, "\xA0"));
  return _react["default"].createElement(_reactstrap.ButtonDropdown, {
    addonType: "prepend",
    isOpen: dropdownOpen,
    toggle: toggle
  }, _react["default"].createElement(_AcceptAs.StyledButton, {
    onClick: handleApprove,
    "data-testid": "accept-as-approve-button"
  }, !isCheckHidden && _react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCheck,
    "aria-hidden": true
  }), approvalMessage), _react["default"].createElement(_AcceptAs.StyledDropdownToggle, {
    "data-testid": "accept-as-toggle"
  }, _react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCaretDown,
    "aria-hidden": true
  })), _react["default"].createElement(_AcceptAs.StyledDropdownMenu, {
    flip: false
  }, _react["default"].createElement(_AcceptAs.StyledDropdownMenuItem, {
    toggle: false,
    key: "knock-source-item-create-new-source"
  }, _react["default"].createElement("label", {
    htmlFor: "create-new-source-radio-button",
    title: "Create a new source",
    onChange: handleChange
  }, _react["default"].createElement(_AcceptAs.StyledRadioInput, {
    "data-testid": "create-new-source-radio-button",
    type: "radio",
    name: "unassigned-source-chooser",
    value: "",
    id: "create-new-source-radio-button",
    checked: !displayName && true
  }), "Create a new source")), sources.map(function (source, index) {
    return _react["default"].createElement(_AcceptAs.StyledDropdownMenuItem, {
      toggle: false,
      key: "knock-source-item-".concat(index)
    }, _react["default"].createElement("label", {
      htmlFor: "unassigned-source-".concat(index, "-radio-button"),
      title: source.title,
      onChange: handleChange
    }, _react["default"].createElement(_AcceptAs.StyledRadioInput, {
      "data-testid": "unassigned-source-".concat(index, "-radio-button"),
      type: "radio",
      name: "unassigned-source-chooser",
      value: source._id,
      id: "unassigned-source-".concat(index, "-radio-button"),
      checked: source._id === sourceId
    }), source.title));
  })));
};
AcceptAs.propTypes = {
  sources: _propTypes["default"].array.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired,
  isCheckHidden: _propTypes["default"].bool
};
var _default = exports["default"] = AcceptAs;